import { useEnum } from "@/api/services/global/enum";
import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Select } from "@/components/elements/Select";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack, Typography, Grid } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useGetUserListPersonInCharge } from "@/api/services/main/user";
import { useMe } from "@/api/services/main/auth";

type TalentFormRecruitmentStatusProps = {};

export const TalentFormRecruitmentStatus: FCC<TalentFormRecruitmentStatusProps> = () => {
  const methods = useFormContext<TTalentForm>();
  const { control, setValue } = methods;
  const { userOptions } = useGetUserListPersonInCharge();
  const { data: meResult } = useMe();
  const { data: recruitmentStatus } = useEnum("ERecruitmentStatus");
  const recruitmentStatusOptions = useMemo(() => recruitmentStatus ?? [], [recruitmentStatus]);

  useEffect(() => {
    const userData = meResult?.data;
    if (userData) {
      if (userData?.id && userData?.isUser) {
        const parsedUserId = Number(userData?.id);

        if (!isNaN(parsedUserId)) {
          setValue("personInChargeId", parsedUserId);
        }
      }
    }
  }, [setValue, meResult]);

  return (
    <InnerBox p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          ステータス状況
        </Typography>

        <Grid mt={1} container spacing={2}>
          <Grid item xs={6}>
            <FormField control={control} name="recruitmentStatus">
              <Select placeholder="選択してください" options={recruitmentStatusOptions} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="personInChargeId">
              <Select options={userOptions} />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
